import React from "react";

const TermsCondition = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>

      <p className="mb-6">
        Welcome to <strong>Daga Gems</strong>, your premier destination for
        exquisite jewelry. Before you embark on your jewelry journey with us,
        please take a moment to review our Terms and Conditions. These terms
        govern your interaction with our website and services. Daga Gems
        reserves the right to update these terms periodically. By continuing to
        use our services, you agree to be bound by the latest version.
      </p>

      <ol className="list-decimal list-inside space-y-6">

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Eligibility Requirements
          </h2>
          <p>
            Users must comply with eligibility under the Indian Contract Act,
            1872. Individuals under 18 years are not permitted to make
            purchases. Services are limited within India, and users must follow
            applicable local laws. Certain states may require additional tax
            documentation.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Pricing and Payment Terms
          </h2>
          <p>
            All prices are in INR and include GST. Payments are accepted only in
            INR. Orders are treated as offers and are confirmed only upon
            dispatch. Partial dispatch counts as partial acceptance.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Your Responsibilities
          </h2>
          <p>
            You must provide accurate and updated information. Incorrect details
            may result in order failure and additional charges. Carefully review
            product descriptions before placing an order.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Restrictions</h2>
          <p>
            Daga Gems may limit quantities or value of purchases per user or
            account. Orders may be restricted based on shared billing/shipping
            details.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Security</h2>
          <p>
            Unauthorized use, hacking, spamming, or misuse of the website is
            strictly prohibited and may lead to legal action.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Order Cancellation
          </h2>
          <p>
            Orders may be canceled due to stock limitations, pricing errors, or
            fraud detection. Additional verification may be required.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Privacy Policy</h2>
          <p>
            Your personal data is handled securely. Please refer to our Privacy
            Policy for detailed information.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Fraudulent Transactions
          </h2>
          <p>
            Fraudulent activity will lead to legal action, including recovery of
            damages and legal costs.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            External Material
          </h2>
          <p>
            Users must not introduce viruses or disrupt the website. We are not
            responsible for interruptions due to technical issues.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Liability</h2>
          <p>
            Daga Gems is not liable for any loss or damage arising from usage of
            the website or purchase activities.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Disclaimer</h2>
          <p>
            Terms may be updated anytime. Continued usage implies acceptance of
            changes.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Copyright & Trademark
          </h2>
          <p>
            All content is owned by Daga Gems. Unauthorized use, reproduction,
            or distribution is prohibited.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Termination & Cancellation
          </h2>
          <p>
            The agreement remains active until terminated. Users may terminate
            via written request. Obligations for existing orders remain valid.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Terms Modification
          </h2>
          <p>
            Terms may be updated without prior notice. Continued use indicates
            acceptance of revised terms.
          </p>
        </li>

      </ol>
    </div>
  );
};

export default TermsCondition;